import { usePermissionsStore } from '@/store/modules/permissions';

/**
 * Directive v-permission
 *
 * Usage:
 *   v-permission="'products.create'"                              - permission unique
 *   v-permission="['products.create', 'products.update']"         - any (logique OR)
 *   v-permission.all="['products.create', 'products.update']"     - all (logique AND)
 *   v-permission.hide="'products.create'"                         - display:none au lieu de retirer du DOM
 */
export const permissionDirective = {
    mounted(el, binding) {
        checkPermission(el, binding);
    },
    updated(el, binding) {
        checkPermission(el, binding);
    },
};

function checkPermission(el, binding) {
    const permissionsStore = usePermissionsStore();
    const { value, modifiers } = binding;

    if (!value) return;

    let hasAccess = false;

    if (Array.isArray(value)) {
        if (modifiers.all) {
            hasAccess = permissionsStore.hasAllPermissions(value);
        } else {
            hasAccess = permissionsStore.hasAnyPermission(value);
        }
    } else {
        hasAccess = permissionsStore.hasPermission(value);
    }

    if (!hasAccess) {
        if (modifiers.hide) {
            el.style.display = 'none';
        } else {
            el.style.display = 'none';
        }
    } else {
        el.style.display = '';
    }
}
